import React from "react";
import { Node_Type } from "./../../ricos-types";
import { Image } from "./../../ui-components";
import { LINK_PREVIEW_VIEWER } from "../data-hooks";
import styles from "../statics/styles/link-preview-scss";
import { LINK_PREVIEW_TYPE } from "../types";
const startsWithHttps = (url) => /^https:/.test(url);
const startsWithHttp = (url) => /^http:/.test(url);
const getHost = (url) => !url ? url : !startsWithHttps(url) && !startsWithHttp(url) ? new URL(`http://${url}`).host : new URL(url).host;
const LinkPreviewViewer = ({ node, helpers }) => {
  const linkPreviewStyles = styles;
  const getUrlForDisplay = (url) => url.replace(/^https?:\/\//, "");
  const onLinkPreviewClick = () => {
    if (node.type === "LINK_PREVIEW") {
      helpers?.onViewerAction?.(
        LINK_PREVIEW_TYPE,
        "Click",
        node.linkPreviewData.link?.url || "",
        node.id,
        {
          type: Node_Type.LINK_PREVIEW,
          linkPreviewData: node.linkPreviewData
        }
      );
    }
  };
  const { title = "", description, thumbnailUrl, link } = node.linkPreviewData;
  const {
    linkPreviewContainer,
    linkPreview,
    linkPreviewUrl,
    linkPreviewInfo,
    linkPreviewTitle,
    linkPreviewImage,
    linkPreviewDescription
  } = linkPreviewStyles;
  return /* @__PURE__ */ React.createElement("div", { className: linkPreviewContainer }, /* @__PURE__ */ React.createElement("figure", { className: linkPreview, "data-hook": LINK_PREVIEW_VIEWER, onClick: onLinkPreviewClick }, thumbnailUrl && /* @__PURE__ */ React.createElement(
    Image,
    {
      containerProps: { className: linkPreviewImage },
      uri: thumbnailUrl,
      width: 400,
      height: 200,
      displayMode: "fill",
      alt: title
    }
  ), /* @__PURE__ */ React.createElement("section", { className: linkPreviewInfo }, /* @__PURE__ */ React.createElement("div", { className: linkPreviewUrl, dir: "auto" }, getUrlForDisplay(getHost(link?.url) || link?.url || "")), /* @__PURE__ */ React.createElement("figcaption", { className: linkPreviewTitle, dir: "auto" }, title), description && /* @__PURE__ */ React.createElement("div", { className: linkPreviewDescription, dir: "auto" }, description))));
};
export {
  LinkPreviewViewer
};
//# sourceMappingURL=link-preview-viewer.js.map
